<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("notifications") }}
      </h1>
    </div>

    <!-- Send Notification Form Section -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="
        $store.getters['checkUserAccess']({
          id: '33',
          action: 'add',
        })
      "
    >
      <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-6">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          {{ $t("send_notification") }}
        </h2>
        <form @submit.prevent="sendNotification">
          <div class="grid gap-6 md:grid-cols-2">
            <BaseInput
              v-model="notificationTitle"
              :label="$t('notification_title')"
              :placeholder="$t('notification_title')"
              :rules="rules"
              :isError="isSubmited && checkRulesIsError(notificationTitle, 'add').isError"
              :errorMsg="isSubmited ? checkRulesIsError(notificationTitle, 'add').errorMsg : ''"
            />
            <div>
              <label class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1">
                {{ $t("send_to") }}
              </label>
              <select
                v-model="sendToType"
                class="bg-white border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="onSendToTypeChange"
              >
                <option value="all">{{ $t("all_users") }}</option>
                <option value="specific">{{ $t("specific_users") }}</option>
              </select>
            </div>
            <div class="md:col-span-2">
              <TextAreaInput
                v-model="notificationDescription"
                :label="$t('notification_description')"
                :placeholder="$t('notification_description')"
                :rules="rules"
                :isError="isSubmited && checkRulesIsError(notificationDescription, 'add').isError"
                :errorMsg="isSubmited ? checkRulesIsError(notificationDescription, 'add').errorMsg : ''"
              />
            </div>
            <div class="md:col-span-2">
              <label class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1">
                {{ $t("notification_action") }}
              </label>
              <select
                v-model="notificationAction"
                class="bg-white border border-gray-300 text-textBlack1 placeholder-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="onNotificationActionChange"
              >
                <option value="">{{ $t("select") || "Select" }}</option>
                <option value="link">{{ $t("link") }}</option>
                <option value="phone number">{{ $t("phone_number") }}</option>
                <option value="perfume">{{ $t("perfume") || "Perfume" }}</option>
                <option value="none">{{ $t("none") }}</option>
              </select>
            </div>
            <BaseInput
              v-if="notificationAction && notificationAction !== 'none' && notificationAction !== 'perfume'"
              v-model="notificationActionData"
              :label="notificationAction === 'link' ? $t('link') : $t('phone_number')"
              :placeholder="notificationAction === 'link' ? $t('link') : $t('phone_number')"
              class="md:col-span-2"
            />
            <div v-if="notificationAction === 'perfume'" class="md:col-span-2">
              <label class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1">
                {{ $t('select_perfume') || 'Select Perfume' }}
              </label>
              <div ref="perfumeSearchContainer" class="relative">
                <BaseInput
                  v-model="perfumeSearchTerm"
                  :placeholder="$t('search_perfume') || 'Search perfume...'"
                  :prefixIcon="'fa-solid fa-search'"
                  @update:modelValue="onPerfumeSearch"
                  @focus="showPerfumeDropdown = true"
                />
                <!-- Dropdown Results -->
                <Transition
                  enter-active-class="transition duration-200 ease-out"
                  enter-from-class="transform scale-95 opacity-0"
                  enter-to-class="transform scale-100 opacity-100"
                  leave-active-class="transition duration-150 ease-in"
                  leave-from-class="transform scale-100 opacity-100"
                  leave-to-class="transform scale-95 opacity-0"
                >
                  <div
                    v-if="showPerfumeDropdown && (perfumeOptions.length > 0 || isLoadingPerfumes)"
                    class="absolute z-50 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-60 overflow-y-auto"
                  >
                    <div v-if="isLoadingPerfumes" class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center">
                      <i class="fa fa-spinner fa-spin mr-2"></i>
                      {{ $t('loading') || 'Loading...' }}
                    </div>
                    <div
                      v-else
                      v-for="perfume in perfumeOptions"
                      :key="perfume.id"
                      @click="selectPerfume(perfume)"
                      class="px-3 py-2 text-sm cursor-pointer transition-colors duration-150 text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                      {{ perfume.value }}
                    </div>
                    <div
                      v-if="!isLoadingPerfumes && perfumeOptions.length === 0 && perfumeSearchTerm"
                      class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400 text-center"
                    >
                      {{ $t('no_data_found') || 'No perfumes found' }}
                    </div>
                  </div>
                </Transition>
                <!-- Selected Perfume Display -->
                <div v-if="selectedPerfumeName" class="mt-2 px-3 py-2 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
                  <div class="flex items-center justify-between">
                    <span class="text-sm text-blue-900 dark:text-blue-200">
                      <i class="fa fa-check-circle mr-2"></i>
                      {{ selectedPerfumeName }}
                    </span>
                    <button
                      @click="clearPerfumeSelection"
                      class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                      type="button"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="sendToType === 'specific'" class="md:col-span-2">
              <label class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1">
                {{ $t("select_users") }}
              </label>
              <!-- Search input for users -->
              <div class="mb-3">
                <BaseInput
                  v-model="userSearchTerm"
                  :placeholder="$t('search') + ' ' + $t('app_users')"
                  :prefixIcon="'fa-solid fa-search'"
                  class="w-full"
                  @update:modelValue="onUserSearch"
                />
              </div>
              <div v-if="isLoadingUsers" class="text-center py-4">
                <img
                  src="../../assets/loading.webp"
                  class="w-8 h-8 animate-pulse mx-auto"
                  alt="Loading..."
                />
                <p class="text-gray-500 dark:text-gray-400 text-sm mt-2">{{ $t("loading") || "Loading..." }}</p>
              </div>
              <div v-else class="max-h-60 overflow-y-auto border border-gray-300 dark:border-gray-600 rounded-lg p-3 bg-white dark:bg-bgFullDark">
                <div
                  v-for="user in appUsers"
                  :key="user.au_id"
                  class="flex items-center mb-2 p-2 hover:bg-gray-50 dark:hover:bg-gray-800 rounded"
                >
                  <input
                    type="checkbox"
                    :value="user.au_id"
                    v-model="selectedUserIds"
                    :id="'user-' + user.au_id"
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    :for="'user-' + user.au_id"
                    class="ml-2 text-sm text-gray-900 dark:text-gray-300 cursor-pointer flex-1"
                  >
                    <span class="font-medium">{{ user.au_name }}</span>
                    <span v-if="user.au_email" class="text-gray-500 dark:text-gray-400 ml-1">
                      ({{ user.au_email }})
                    </span>
                    <span v-if="user.au_phone" class="text-gray-500 dark:text-gray-400 ml-1">
                      - {{ user.au_phone }}
                    </span>
                  </label>
                </div>
                <p v-if="appUsers.length === 0 && !isLoadingUsers" class="text-gray-500 dark:text-gray-400 text-sm text-center py-4">
                  {{ $t("no_users_found") }}
                </p>
                <div v-if="selectedUserIds.length > 0" class="mt-3 pt-3 border-t border-gray-300 dark:border-gray-600">
                  <p class="text-sm text-gray-600 dark:text-gray-400">
                    {{ $t("selected") }}: <strong>{{ selectedUserIds.length }}</strong> {{ $t("users") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="md:col-span-2">
              <ButtonInput
                type="submit"
                :label="$t('send_notification')"
                :isLoading="isBtnLoading"
              />
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Notifications List Section -->
    <div
      class="px-6 py-4"
      v-if="
        $store.getters['checkUserAccess']({
          id: '33',
          action: 'view',
        })
      "
    >
      <div class="my-2 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl">
        <div class="relative overflow-x-auto mt-4 mb-6">
          <div class="flex items-center justify-between pb-4 mx-5">
            <div class="flex items-center space-x-4">
              <BaseInput
                :modelValue="$store.state.notification.search"
                @update:modelValue="handleSearchInput"
                :placeholder="$t('search')"
                :prefixIcon="'fa-solid fa-search'"
                class="w-40 md:w-full"
              />
            </div>
          </div>
          <EasyDataTable
            :headers="headers"
            :items="filterItems"
            :loading="isLoadingData"
            :alternating="false"
            :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
            :rows-items="[25, 50, 100]"
            rows-per-page="10"
            :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
          >
            <template #loading>
              <div class="flex items-center justify-center py-8">
                <img
                  src="../../assets/loading.webp"
                  class="w-16 h-16 animate-pulse"
                  alt="Loading..."
                />
              </div>
            </template>
            <template #item-no_title="item">
              <span class="font-semibold text-gray-900 dark:text-white">
                {{ item.no_title }}
              </span>
            </template>
            <template #item-no_desc="item">
              <span class="text-gray-700 dark:text-gray-300">
                {{ item.no_desc }}
              </span>
            </template>
            <template #item-user_ids="item">
              <span v-if="!item.user_ids || item.user_ids.length === 0" class="text-blue-600 dark:text-blue-400">
                {{ $t("all_users") }}
              </span>
              <span v-else class="text-gray-700 dark:text-gray-300">
                {{ $t("specific_users") }} ({{ Array.isArray(item.user_ids) ? item.user_ids.length : 1 }})
              </span>
            </template>
            <template #item-no_is_read="item">
              <span
                :class="
                  item.no_is_read
                    ? 'px-2 py-1 text-xs rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                    : 'px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
                "
              >
                {{ item.no_is_read ? $t("read") : $t("unread") }}
              </span>
            </template>
            <template #item-created_at="item">
              <span class="text-gray-600 dark:text-gray-400">
                {{ formatDate(item.created_at) }}
              </span>
            </template>
            <template #item-users="item">
              <span class="text-gray-700 dark:text-gray-300">
                {{ item.users ? item.users.name : '-' }}
              </span>
            </template>
            <template #empty-message>
              <div class="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400">
                <i class="fa-solid fa-inbox text-4xl mb-4"></i>
                <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
              </div>
            </template>
          </EasyDataTable>
        </div>
      </div>
    </div>
  </div>
  <LoadingProgress v-show="isLoadingData" />
</template>

<script>
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import LoadingProgress from "../../components/loading-progress.vue";
import { formatDate } from "../../utils/functions";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main";

export default {
  name: "notification-view",
  components: {
    HeaderApp,
    BaseInput,
    TextAreaInput,
    ButtonInput,

    LoadingProgress,
  },
  data() {
    return {
      notificationTitle: "",
      notificationDescription: "",
      sendToType: "all",
      selectedUserIds: [],
      appUsers: [],
      isSubmited: false,
      userSearchTerm: "",
      isLoadingUsers: false,
      userSearchTimeout: null,
      notificationAction: "",
      notificationActionData: "",
      selectedPerfumeId: "",
      selectedPerfumeName: "",
      perfumeOptions: [],
      perfumeSearchTerm: "",
      isLoadingPerfumes: false,
      perfumeSearchTimeout: null,
      showPerfumeDropdown: false,
      rules: [
        (value) => {
          if (value) return true;
          return this.$t("you_must_fill_this_field");
        },
      ],
    };
  },
  computed: {
    filterItems() {
      return this.$store.getters["notification/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.notification.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.notification.isBtnLoading;
    },
    headers() {
      const isRtl = this.$store.getters['isRtl'];
      if (isRtl) {
        // RTL order: #, title, description, send_to, status, created_by, created_at
        return [
          { text: "#", value: "no_id", sortable: true },
          { text: this.$t("notification_title"), value: "no_title", sortable: true },
          { text: this.$t("notification_description"), value: "no_desc", sortable: true },
          { text: this.$t("send_to"), value: "user_ids", sortable: false },
          { text: this.$t("status"), value: "no_is_read", sortable: true },
          { text: this.$t("created_by"), value: "users.name", sortable: true },
          { text: this.$t("created_at"), value: "created_at", sortable: true },
        ];
      } else {
        // LTR order: #, title, description, send_to, status, created_by, created_at
        return [
          { text: "#", value: "no_id", sortable: true },
          { text: this.$t("notification_title"), value: "no_title", sortable: true },
          { text: this.$t("notification_description"), value: "no_desc", sortable: true },
          { text: this.$t("send_to"), value: "user_ids", sortable: false },
          { text: this.$t("status"), value: "no_is_read", sortable: true },
          { text: this.$t("created_by"), value: "users.name", sortable: true },
          { text: this.$t("created_at"), value: "created_at", sortable: true },
        ];
      }
    },
  },
  created() {
    this.getData();
    this.loadAppUsers();
    // Add click outside handler for perfume dropdown
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    // Remove click outside handler
    document.removeEventListener('click', this.handleClickOutside);
    // Clear timeouts
    if (this.perfumeSearchTimeout) {
      clearTimeout(this.perfumeSearchTimeout);
    }
  },
  methods: {
    handleSearchInput(value) {
      this.$store.commit("notification/SET_SEARCH", value);
      // Refresh data with search
      this.getData();
    },
    formatDate(date) {
      return formatDate(date);
    },
    checkRulesIsError(value, action, rules = this.rules) {
      for (let i = 0; i < rules.length; i++) {
        const result = rules[i](value);
        if (result !== true) {
          return {
            isError: true,
            errorMsg: result,
          };
        }
      }
      return {
        isError: false,
        errorMsg: "",
      };
    },
    async getData() {
      this.$store.state.notification.isLoadingData = true;
      await this.$store.dispatch("notification/getItems", {
        sortBy: 'no_id',
        sortType: 'desc',
        rowsPerPage: 15,
        search: this.$store.state.notification.search || '',
      });
    },
    async loadAppUsers(searchTerm = "") {
      try {
        this.isLoadingUsers = true;
        // Fetch only first 15 users initially, or search results
        const response = await this.$store.dispatch("app_user/getItems", {
          page: 1,
          rowsPerPage: 15,
          search: searchTerm,
          sortBy: 'au_id',
          sortType: 'desc',
        });
        // Handle paginated response
        if (response && response.data) {
          this.appUsers = response.data.data || response.data || [];
        } else if (Array.isArray(response)) {
          this.appUsers = response;
        } else {
          this.appUsers = [];
        }
      } catch (error) {
        console.error("Error loading app users:", error);
        this.appUsers = [];
      } finally {
        this.isLoadingUsers = false;
      }
    },
    onUserSearch(value) {
      // Clear previous timeout
      if (this.userSearchTimeout) {
        clearTimeout(this.userSearchTimeout);
      }
      
      // Debounce search - wait 500ms after user stops typing
      this.userSearchTimeout = setTimeout(() => {
        this.loadAppUsers(value);
      }, 500);
    },
    onSendToTypeChange() {
      if (this.sendToType === "all") {
        this.selectedUserIds = [];
        this.userSearchTerm = "";
        this.appUsers = [];
      } else {
        // Load first 15 users when switching to specific
        this.loadAppUsers("");
      }
    },
    onNotificationActionChange() {
      if (this.notificationAction === 'perfume') {
        // Don't load perfumes automatically - wait for user to search
        this.showPerfumeDropdown = false;
        this.perfumeOptions = [];
      } else {
        // Clear perfume selection when switching to other actions
        this.selectedPerfumeId = "";
        this.selectedPerfumeName = "";
        this.perfumeOptions = [];
        this.perfumeSearchTerm = "";
        this.showPerfumeDropdown = false;
        this.notificationActionData = "";
      }
    },
    async loadPerfumes(searchTerm = "") {
      try {
        this.isLoadingPerfumes = true;
        const response = await this.$store.dispatch("item_list/getItems", {
          page: 1,
          rowsPerPage: 50,
          search: searchTerm || "",
          sortBy: 'i_id',
          sortType: 'desc',
        });
        
        if (response && response.data && response.data.items) {
          const items = response.data.items.data || [];
          this.perfumeOptions = items
            .filter(item => item.i_barcode && item.i_barcode.trim() !== '') // Only include items with barcode
            .map(item => ({
              id: item.i_barcode, // Use barcode as ID since API expects barcode
              value: `${item.i_name}${item.i_barcode ? ' (' + item.i_barcode + ')' : ''}`,
              i_id: item.i_id, // Keep i_id for reference
              i_barcode: item.i_barcode
            }));
        } else {
          this.perfumeOptions = [];
        }
      } catch (error) {
        console.error("Error loading perfumes:", error);
        this.perfumeOptions = [];
      } finally {
        this.isLoadingPerfumes = false;
      }
    },
    onPerfumeSearch(value) {
      // Clear previous timeout
      if (this.perfumeSearchTimeout) {
        clearTimeout(this.perfumeSearchTimeout);
      }
      
      // Show dropdown when user starts typing
      if (value && value.length > 0) {
        this.showPerfumeDropdown = true;
      }
      
      // Debounce search - wait 500ms after user stops typing
      this.perfumeSearchTimeout = setTimeout(() => {
        if (value && value.trim().length > 0) {
          this.loadPerfumes(value.trim());
        } else {
          // If search is empty, clear results
          this.perfumeOptions = [];
          this.showPerfumeDropdown = false;
        }
      }, 500);
    },
    selectPerfume(perfume) {
      this.selectedPerfumeId = perfume.id; // This is the barcode
      this.selectedPerfumeName = perfume.value;
      // Store barcode in notificationActionData since API expects barcode, not i_id
      this.notificationActionData = perfume.i_barcode || perfume.id.toString();
      this.perfumeSearchTerm = "";
      this.showPerfumeDropdown = false;
      this.perfumeOptions = [];
    },
    clearPerfumeSelection() {
      this.selectedPerfumeId = "";
      this.selectedPerfumeName = "";
      this.notificationActionData = "";
      this.perfumeSearchTerm = "";
      this.showPerfumeDropdown = false;
      this.perfumeOptions = [];
    },
    handleClickOutside(event) {
      // Close perfume dropdown if clicking outside
      if (this.showPerfumeDropdown && this.$refs.perfumeSearchContainer && 
          !this.$refs.perfumeSearchContainer.contains(event.target)) {
        this.showPerfumeDropdown = false;
      }
    },
    async sendNotification() {
      // Mark form as submitted to show validation errors
      this.isSubmited = true;
      
      // Validate
      if (!this.notificationTitle || !this.notificationDescription) {
        const t = i18n.global.t;
        toast("error", t("please_fill_all_fields"));
        return;
      }

      if (this.sendToType === "specific" && this.selectedUserIds.length === 0) {
        const t = i18n.global.t;
        toast("error", t("please_select_at_least_one_user"));
        return;
      }

      if (this.notificationAction && this.notificationAction !== "none") {
        if (this.notificationAction === "perfume" && !this.selectedPerfumeId) {
          const t = i18n.global.t;
          toast("error", t("please_select_perfume") || "Please select a perfume");
          return;
        } else if (this.notificationAction !== "perfume" && !this.notificationActionData) {
          const t = i18n.global.t;
          toast("error", t("please_fill_all_fields"));
          return;
        }
      }

      const payload = {
        title: this.notificationTitle,
        description: this.notificationDescription,
        user_ids: this.sendToType === "all" ? null : this.selectedUserIds,
        no_action: this.notificationAction || null,
        no_action_data: this.notificationAction === 'perfume' ? this.selectedPerfumeId.toString() : (this.notificationActionData || null),
      };

      try {
        await this.$store.dispatch("notification/sendNotification", payload);
        
        // Reset form
        this.notificationTitle = "";
        this.notificationDescription = "";
        this.sendToType = "all";
        this.selectedUserIds = [];
        this.userSearchTerm = "";
        this.notificationAction = "";
        this.notificationActionData = "";
        this.selectedPerfumeId = "";
        this.selectedPerfumeName = "";
        this.perfumeOptions = [];
        this.perfumeSearchTerm = "";
        this.showPerfumeDropdown = false;
        this.isSubmited = false; // Reset submission flag
        
        // Refresh notifications list
        this.getData();
      } catch (error) {
        console.error("Error sending notification:", error);
      }
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
